"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireWildcard(require("../../../../../../ui/Button"));
var _actions = require("../../store/actions");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Svg = _styledComponents.default.svg.attrs({
  width: '15',
  height: '18',
  viewBox: '0 0 15 18',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover > path {\n        fill: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var CopyIcon = function CopyIcon() {
  return /*#__PURE__*/_react.default.createElement(Svg, null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.91701 13.896C5.37501 13.896 4.90967 13.7013 4.52101 13.312C4.13234 12.9233 3.93801 12.4583 3.93801 11.917V2.354C3.93801 1.81267 4.13234 1.34733 4.52101 0.958C4.90967 0.569333 5.37501 0.375 5.91701 0.375H12.979C13.521 0.375 13.9863 0.569333 14.375 0.958C14.7637 1.34733 14.958 1.81267 14.958 2.354V11.917C14.958 12.4583 14.7637 12.9233 14.375 13.312C13.9863 13.7013 13.521 13.896 12.979 13.896H5.91701ZM5.91701 11.917H12.979V2.354H5.91701V11.917ZM2.18801 17.625C1.64601 17.625 1.18067 17.4307 0.792008 17.042C0.402675 16.6527 0.208008 16.1873 0.208008 15.646V5.167C0.208008 4.903 0.308675 4.67367 0.510008 4.479C0.711341 4.285 0.944008 4.188 1.20801 4.188C1.47201 4.188 1.70134 4.285 1.89601 4.479C2.09067 4.67367 2.18801 4.903 2.18801 5.167V15.646H10.167C10.4303 15.646 10.6593 15.7433 10.854 15.938C11.0487 16.132 11.146 16.361 11.146 16.625C11.146 16.889 11.0487 17.1217 10.854 17.323C10.6593 17.5243 10.4303 17.625 10.167 17.625H2.18801ZM5.91701 2.354V11.917V2.354Z",
    fill: "#3d3d3d"
  }));
};
var CopyInfoButton = function CopyInfoButton(_ref) {
  var children = _ref.children,
    className = _ref.className,
    offerID = _ref.offerID,
    theme = _ref.theme,
    queryID = _ref.queryID,
    width = _ref.width,
    iconClassName = _ref.iconClassName,
    activeTheme = _ref.activeTheme;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var handleClick = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.copyOfferToBuffer)(offerID, queryID));
  }, [dispatch, offerID, queryID]);
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: className,
    icon: /*#__PURE__*/_react.default.createElement(CopyIcon, null),
    width: width,
    iconClassName: iconClassName,
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    size: _Button.SIZES.MEDIUM,
    theme: theme,
    activeTheme: activeTheme,
    title: t('COPY_TOUR_INFO_BUTTON'),
    onClick: handleClick
  }, children);
};
CopyInfoButton.propTypes = {
  className: _propTypes.default.string,
  offerID: _propTypes.default.string.isRequired,
  theme: _propTypes.default.oneOf(Object.values(_Button.THEMES)),
  width: _propTypes.default.oneOf(Object.values(_Button.WIDTHS)),
  queryID: _propTypes.default.string.isRequired
};
var _default = exports.default = (0, _react.memo)(CopyInfoButton);